import { useEffect, useState, useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import { motion, animate } from 'framer-motion'

function AnimatedCounter({ from = 0, to, duration = 2, suffix = '', formatNumber = false }) {
  const [displayValue, setDisplayValue] = useState(from)
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  })
  const hasAnimated = useRef(false)

  useEffect(() => {
    if (inView && !hasAnimated.current) {
      hasAnimated.current = true
      
      const controls = animate(from, to, {
        duration,
        onUpdate: (value) => {
          setDisplayValue(Math.round(value))
        }
      })
      
      return () => controls.stop()
    }
  }, [inView, from, to, duration])

  const formatDisplayValue = (value) => {
    if (formatNumber) {
      return value.toLocaleString()
    }
    return value
  }

  return (
    <motion.span
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.5 }}
    >
      {formatDisplayValue(displayValue)}{suffix}
    </motion.span>
  )
}

export default AnimatedCounter